// MainContentContext.tsx

import React, { ReactNode, createContext, useContext, useRef } from 'react';

import { MainContainerRefContext } from './MainContainerRefContext';
import { PageAnnouncements } from '../components/shared/announcements/PageAnnouncements';

type MainContentDivContextType = {
    mainContentDivRef: React.RefObject<HTMLDivElement | null>;
};

const MainContentDivContext = createContext<MainContentDivContextType | undefined>(undefined);

export const useMainContentDiv = () => {
    const context = useContext(MainContentDivContext);
    if (!context) {
        throw new Error('useMainContentDiv must be used within a MainContentDivProvider');
    }
    return context;
};

export const MainContentDivProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const mainContentDivRef = useRef<HTMLDivElement>(null);

    return (
        <MainContainerRefContext.Provider value={mainContentDivRef}>
            <div ref={mainContentDivRef} id="MainContent">
                <PageAnnouncements />
                {children}
            </div>
        </MainContainerRefContext.Provider>
    );
};
